<template>
  <div class="record__status">
    <div class="record__status-badge">
      <transition name="fade" v-on:leave="leave" v-on:enter="enter">
        <div
          v-if="show"
          :data-test-id="`status--${currentStatus.toLowerCase()}`"
          :class="`status--${currentStatus.toLowerCase()}`"
          class="status"
        >
          <span v-if="currentStatus">{{
            $t('order_status.' + currentStatus.replace(' ', '_'))
          }}</span>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="!show" :class="`status--${nextStatus.toLowerCase()}`" class="status">
          <span v-if="nextStatus">{{ $t('order_status.' + nextStatus.replace(' ', '_')) }}</span>
        </div>
      </transition>
    </div>
    <div class="records__return-status" v-if="order.returning_status_label">
      <div class="records__returned" v-if="order.returning_status_label.returned">
        <SvgIcon class="return-icon" height="12" width="12" icon="Returned" />
        <span>{{ $t('timeline.return') }}</span>
      </div>
      <div class="records__returning" v-else>
        <SvgIcon class="return-icon" height="12" width="12" icon="Returning" />
        <span>{{ $t('timeline.returning') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object
    }
  },
  data() {
    return {
      currentStatus: '',
      nextStatus: '',
      show: true
      // status : this.order && this.order.status || ''
    }
  },
  computed: {
    status() {
      return (this.order && this.order.status) || ''
    }
  },
  methods: {
    enter() {
      this.currentStatus = this.nextStatus
    },
    leave() {
      this.currentStatus = this.nextStatus
    }
  },
  mounted() {
    this.currentStatus = this.status
  },
  watch: {
    status(val, oldVal) {
      if (val !== oldVal) {
        this.nextStatus = val
        this.show = !this.show
      }
    }
  }
}
</script>

<i18n src="@/locales2/share/orderTimeline.json"></i18n>

<style lang="scss" scoped>
.record__status {
  .fade-enter-active,
  .fade-leave-active {
    transition: all 1s;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .fade-enter {
    transform: translateY(-30px);
  }

  .fade-leave-active {
    transform: translateY(-30px);
  }

  .records__return-status {
    font-size: 13px;
    margin-top: 4px;
  }

  .record__status-badge {
    position: relative;
    height: 35px;
  }

  .return-icon {
    display: inline-block;
    vertical-align: text-top;
    margin-right: 4px;
  }

  .records__returned {
    color: #1dc05e;
  }

  .records__returning {
    color: #ff8200;
  }

  .status {
    border-radius: 54px;
    padding: 6px 15px;
    text-align: center;
    font-weight: 500;
    position: absolute;
    width: 110px;
  }

  .status--confirming {
    background-color: rgba(26, 26, 26, 0.05);
    width: 125px;
  }

  .status--cancelled {
    color: #ff3b30;
    background-color: rgba(255, 59, 48, 0.05);
  }

  .status--completed {
    color: $status_completed;
    background-color: rgba(29, 192, 94, 0.05);
  }

  .status--in.process {
    color: #007cff;
    background-color: rgba(0, 124, 255, 0.1);
  }

  .status--accepted {
    color: #ff8200;
    background-color: rgba(255, 130, 0, 0.1);
  }

  .status--assigning,
  .status--idle {
    background-color: rgba(26, 26, 26, 0.05);
  }
  //
  // &.status--paying {
  //   background: $status_paying;
  // }
}
</style>
